import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ItemState } from '../../models/core';
 
@Component({
    selector: 'app-update-state-form',
    templateUrl: './update-state-form.component.html',
    styleUrls: ['./update-state-form.component.scss'],
    standalone: false
})
export class UpdateStateFormComponent {
  @Output() statusSubmitted = new EventEmitter<any>();
  @Input() tabName: string;
  @Input() currentTaskType: string;

  FormModel = {
    selectedState: '',
    selectedReason: ''
  }

  stateOptions = [
    { label: 'Failed Attempt', value: 'FailedAttempt' },
    { label: 'Picked Up', value: 'PickedUp' },
  ];
 
  reasonOptions = [
    { label: 'No goods Available For Pickup At Senders stated address', value: '7' },
    { label: 'Consumer not present', value: '10' },
    { label: 'No access', value: '2' },
    { label: 'Not informed', value: '3' },
    { label: 'Capacity shortage', value: '75' },
    { label: 'Goods not ready collection', value: '232' },
    { label: 'Box/Locker malfunction', value: '229' },
    { label: 'No connection to box', value: '265' }
  ];

  @ViewChild('updateStateFooter', { static: true }) updateStateFooter!: TemplateRef<any>;


  /**
   * based on tab, set state update dropdown values
   */
  get stateOptionsForTab(): { label: string; value: string }[] {
    return this.tabName === 'plannedTab'
      ? this.plannedTaskStateOptions
      : this.stateOptions;
  }

  get dropdownLabel(): string {
    return this.tabName === 'plannedTab' ? 'Task Type' : 'State';
  }
  /**
   * set values for planned tab task type- handover to deliver and vice versa
   */
  get plannedTaskStateOptions() {
    if (this.currentTaskType === 'Deliver') {
      return [{ label: 'HandOver', value: 'HandOver' }];
    }
    else if (this.currentTaskType === 'HandOver') {
      return [{ label: 'Deliver', value: 'Deliver' }];
    }
    else {
      return [];
    }
  }

  onStateChange() {
    if (this.FormModel.selectedState !== ItemState.FailedAttempt) {
      this.FormModel.selectedReason = '';
    }
  }
 
  submitStatusUpdate() {
    if (!this.FormModel.selectedState || (this.FormModel.selectedState === ItemState.FailedAttempt && !this.FormModel.selectedReason)) return;
    this.statusSubmitted.emit({
      state: this.FormModel.selectedState,
      reason: this.FormModel.selectedReason
    });
  }

}
 